const paywallFormSelector = '.js-paywall_form';
const previewFrameWrapperSelector = '.js-paywall_preview_frame';
const previewFrameSelector = '#paywall_preview_frame';
const previewFrameMinHeight = 300;
const previewLoadingClass = 'is_loading';
// A spinner that only flashes is worse than none, and a frame that never
// reports back must not spin forever.
const previewMinLoadingMs = 800;
const previewMaxLoadingMs = 4000;
const previewFrame = () => document.querySelector(previewFrameSelector);
const previewWrapper = () => document.querySelector(previewFrameWrapperSelector);
const isPreviewMessage = (event, type) => { var _a, _b; return event.origin === window.location.origin && ((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === type && event.source === ((_b = previewFrame()) === null || _b === void 0 ? void 0 : _b.contentWindow); };
// Unpoly also validates on `change`, which fires when a field loses focus,
// e.g. when the publisher clicks into the preview. Re-rendering then would
// throw away what they just opened in it, so only changed values re-render.
// A query counts as rendered once its fragment has been swapped in.
let pendingPreviewQuery;
let lastPreviewQuery;
// The overlay goes up as soon as the form starts validating, before the
// preview fragment is requested, so the reload never shows through. A request
// that never renders (aborted, offline, server error) must not leave it up,
// so the start arms a failsafe that the swapped-in fragment disarms.
let loadingSince = 0;
let loadingFailsafe;
const stopLoading = (wrapper) => {
    window.clearTimeout(loadingFailsafe);
    wrapper === null || wrapper === void 0 ? void 0 : wrapper.classList.remove(previewLoadingClass);
    loadingSince = 0;
};
const startLoading = () => {
    var _a;
    window.clearTimeout(loadingFailsafe);
    loadingSince = Date.now();
    (_a = previewWrapper()) === null || _a === void 0 ? void 0 : _a.classList.add(previewLoadingClass);
    loadingFailsafe = window.setTimeout(() => {
        pendingPreviewQuery = undefined;
        stopLoading(previewWrapper());
    }, previewMaxLoadingMs);
};
window.up.on(document, 'up:form:validate', paywallFormSelector, event => {
    // the hidden Phoenix _method=put field would otherwise make Plug.MethodOverride
    // turn this POST into a PUT, which has no matching /preview route
    event.params.delete('_method');
    const query = event.params.toQuery();
    if (query === lastPreviewQuery || query === pendingPreviewQuery) {
        event.preventDefault();
        return;
    }
    pendingPreviewQuery = query;
    startLoading();
});
// The frame reports its content height whenever the paywall changes size,
// e.g. when the publisher switches the billing period or opens a plan card.
let lastFrameHeight;
const setFrameHeight = (frame, height) => {
    lastFrameHeight = Math.max(previewFrameMinHeight, Math.ceil(height));
    frame.style.height = `${lastFrameHeight}px`;
};
// The state above outlives Unpoly page changes; a freshly rendered settings
// form (never swapped by a preview update) marks a new page.
window.up.compiler(paywallFormSelector, () => {
    window.clearTimeout(loadingFailsafe);
    loadingSince = 0;
    pendingPreviewQuery = undefined;
    lastPreviewQuery = undefined;
    lastFrameHeight = undefined;
});
window.addEventListener('message', (event) => {
    if (!isPreviewMessage(event, 'steady:paywall_preview_height') || typeof event.data.height !== 'number')
        return;
    const frame = previewFrame();
    if (!frame)
        return;
    setFrameHeight(frame, event.data.height);
});
// Every preview update swaps in a fresh iframe (reloading a kept one left the
// widget in a broken state). The new frame starts at the previous height and
// stays under the overlay until its widget has mounted.
window.up.compiler(previewFrameWrapperSelector, (wrapper) => {
    const frame = wrapper.querySelector(previewFrameSelector);
    if (!frame)
        return;
    if (pendingPreviewQuery)
        lastPreviewQuery = pendingPreviewQuery;
    pendingPreviewQuery = undefined;
    window.clearTimeout(loadingFailsafe);
    if (lastFrameHeight)
        frame.style.height = `${lastFrameHeight}px`;
    if (!loadingSince)
        loadingSince = Date.now();
    wrapper.classList.add(previewLoadingClass);
    let revealTimer;
    const reveal = () => {
        const remaining = Math.max(0, previewMinLoadingMs - (Date.now() - loadingSince));
        window.clearTimeout(revealTimer);
        revealTimer = window.setTimeout(() => stopLoading(wrapper), remaining);
    };
    const onReady = (event) => {
        if (isPreviewMessage(event, 'steady:paywall_preview_ready'))
            reveal();
    };
    window.addEventListener('message', onReady);
    const fallbackTimer = window.setTimeout(reveal, previewMaxLoadingMs);
    // The frame may have mounted before this compiler ran, e.g. on the initial
    // page load. Its document then already carries the ready mark, and its
    // height message is gone, so the height is read from the document instead.
    const frameDocument = frame.contentDocument;
    if (frameDocument === null || frameDocument === void 0 ? void 0 : frameDocument.documentElement.dataset.paywallPreviewReady) {
        setFrameHeight(frame, frameDocument.body.offsetHeight);
        reveal();
    }
    return () => {
        window.removeEventListener('message', onReady);
        window.clearTimeout(fallbackTimer);
        window.clearTimeout(revealTimer);
    };
});
export {};
